export const COURIER_MODES_ARRAY = ['WALKING', 'BICYCLING', 'DRIVING'] as const;